import { Component, HostListener, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { IntercomService } from './shared/services/intercom/intercom.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {
  title = 'app';
  private routerSub: Subscription;

  constructor(
    translate: TranslateService,
    private intercomService: IntercomService
  ) {
    intercomService.init();

    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('en');

    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');

    if (window.location.href.indexOf('farmplanapps') != -1) {
      window.location.href =
        window.location.origin + '/assets/we-have-moved.html';
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.intercomService.onResize();
  }

  ngOnDestroy() {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }
}
